import app from 'flarum/common/app';
import { BooleanGambit } from 'flarum/common/query/IGambit';
export default class SolutionGambit extends BooleanGambit {
  key() {
    return app.translator.trans('fof-best-answer.lib.gambits.solution.key', {}, true);
  }
  filterKey() {
    return 'solution';
  }
}
flarum.reg.add('fof-best-answer', 'common/gambits/SolutionGambit', SolutionGambit);